// extracted by mini-css-extract-plugin
export var errorBanner = "_ji-2";
export var scroller = "_ji-0";
export var thinking = "_ji-1";
export var visuallyHidden = "_ji-3";